<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="heading">1.</h2>
<p class="firstparagraph"><span class="dropcap">T</span><span>wo years before leaving home my father said to my mother that I was very ugly. The sentence was uttered under his breath, in the apartment that my parents, newly married, had bought at the top of Via San Giacomo dei Capri, in Rione Alto. Everything—the spaces of Naples, the blue light of a frigid February, those words—remained fixed. But I slipped away, and am still slipping away, within these lines that are intended to give me a story, while in fact I am nothing, nothing of my own, nothing that has really begun or really been brought to completion: only a tangled knot, and nobody, not even the one who at this moment is writing, knows if it contains the right thread for a story or is merely a snarled confusion of suffering, without redemption.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// lying-life-5.vue?2caa2958